import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdaptiveFilter, Box, Option, OptionKey, SelectDropdown } from '@common-fe/common-fe';

interface SpendLimitsPeriodFilterProps {
  isMobile: boolean;
  periodOptions: Option[];
  selectedPeriod?: OptionKey;
  onPeriodChange?: (value: OptionKey) => void;
  isPeriodLoading?: boolean;
  testIdPrefix: string;
  isFilterApplied: boolean;
  isFilterVisible: boolean;
  setIsFilterVisible: (value: boolean) => void;
  handleCancelFilter: () => void;
  handleSubmitFilter: () => void;
  handleResetFilter: () => void;
  filterPeriodValue: OptionKey[];
  onFilterPeriodChange: (value: OptionKey[]) => void;
}

export const SpendLimitsPeriodFilter: React.FC<SpendLimitsPeriodFilterProps> = ({
  isMobile,
  periodOptions,
  selectedPeriod,
  onPeriodChange,
  isPeriodLoading,
  testIdPrefix,
  isFilterApplied,
  isFilterVisible,
  setIsFilterVisible,
  handleCancelFilter,
  handleSubmitFilter,
  handleResetFilter,
  filterPeriodValue,
  onFilterPeriodChange,
}) => {
  const { t } = useTranslation();

  if (!isMobile) {
    return (
      <Box width="230px" margin={{ left: 'spacing8' }}>
        <SelectDropdown
          id={`${testIdPrefix}Period`}
          testId={`${testIdPrefix}-period`}
          name={`${testIdPrefix}Period`}
          prefix={t('Spend period')}
          isLoading={isPeriodLoading}
          singleMode
          activeTitle
          options={periodOptions}
          value={selectedPeriod}
          onChange={onPeriodChange}
        />
      </Box>
    );
  }

  return (
    <AdaptiveFilter
      isFilterApplied={isFilterApplied}
      testId={`${testIdPrefix}-filter`}
      title={t('Spend period')}
      onClear={handleResetFilter}
      isVisible={isFilterVisible}
      onSetIsVisible={setIsFilterVisible}
      footer={
        <AdaptiveFilter.Footer
          testId={`${testIdPrefix}-filter-footer`}
          onCancel={handleCancelFilter}
          onSubmit={handleSubmitFilter}
        />
      }
    >
      <AdaptiveFilter.Select
        testId={`${testIdPrefix}-period-select`}
        singleMode
        label={t('Spend period')}
        options={periodOptions}
        value={filterPeriodValue}
        onChangeValue={onFilterPeriodChange}
      />
    </AdaptiveFilter>
  );
};
